import { useState } from 'react';
import { topics } from '@/mocks/homeData';
import SectionHeading from './SectionHeading';

export default function TopicWall() {
  const [active, setActive] = useState<string>('');

  return (
    <section id="topics" className="w-full bg-background-100 border-b border-background-200">
      <div className="px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <SectionHeading
          index="01"
          kicker="TOPIC WALL"
          title="话题墙：从标签进入，直接落到具体的深扒长图"
          desc="话题按被翻牌次数排列，热度越高的标签，背后的长图组越完整。点任意标签即可锁定这一条深扒线索。"
        />

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-9">
            <div className="flex flex-wrap gap-2.5 md:gap-3">
              {topics.map((topic, i) => {
                const isActive = active === topic.id;
                const sizeClass =
                  i < 3
                    ? 'text-sm md:text-base px-4 py-2.5'
                    : i < 7
                      ? 'text-sm px-3.5 py-2'
                      : 'text-xs md:text-sm px-3 py-1.5';
                return (
                  <button
                    key={topic.id}
                    type="button"
                    onClick={() => setActive(isActive ? '' : topic.id)}
                    className={`inline-flex items-center gap-2 rounded-full border font-label whitespace-nowrap transition-colors cursor-pointer ${sizeClass} ${
                      isActive
                        ? 'bg-primary-500 border-primary-500 text-background-50'
                        : topic.hot
                          ? 'bg-background-50 border-primary-300 text-primary-700 hover:bg-primary-100/60'
                          : 'bg-background-50 border-background-300 text-foreground-700 hover:border-secondary-400'
                    }`}
                  >
                    <span>{topic.label}</span>
                    <span className={`text-[11px] ${isActive ? 'text-background-50/80' : 'text-foreground-400'}`}>
                      {topic.count}
                    </span>
                    {topic.hot && !isActive && (
                      <i className="ri-fire-fill text-accent-500 text-xs"></i>
                    )}
                  </button>
                );
              })}
            </div>
            <p className="mt-5 text-xs text-foreground-500 font-label">
              {active
                ? `已锁定话题：${topics.find((t) => t.id === active)?.label}，下方深扒速览将按该线索优先排列`
                : '共 12 个常驻话题，其中 4 个为当前高热标签'}
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="h-full rounded-lg border border-background-300 bg-background-50 p-5 flex flex-col justify-between">
              <div>
                <p className="text-xs tracking-[0.2em] text-foreground-500 font-label">本周新增</p>
                <p className="mt-3 font-heading text-3xl font-bold text-foreground-950">+28</p>
                <p className="mt-1 text-sm text-foreground-600 font-label">组深扒长图</p>
              </div>
              <div className="mt-6 space-y-2.5">
                {['长图深扒', '多图对比', '时间线还原'].map((name, idx) => (
                  <div key={name} className="flex items-center gap-2 text-xs font-label text-foreground-700">
                    <span className={`w-1.5 h-1.5 rounded-full ${idx === 0 ? 'bg-primary-500' : idx === 1 ? 'bg-accent-500' : 'bg-secondary-500'}`}></span>
                    {name}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}